import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const [activeItem, setActiveItem] = useState("DASHBOARD");
  const navigate = useNavigate();

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (isLoggedIn !== "true") navigate("/AuthLogin");
  }, [navigate]);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/AuthLogin");
  };

  // Dashboard Home
  const DashboardHome = () => (
    <div style={styles.card}>
      <p style={styles.fsXl}>
        Hello <strong>{localStorage.getItem("name") || "User"}</strong> (
        <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={handleLogout}>
          Log out
        </span>
        )
      </p>
      <p style={styles.fsMd}>
        From your account dashboard you can view your{" "}
        <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => setActiveItem("ORDERS")}>
          recent orders
        </span>{" "}
        or{" "}
        <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => setActiveItem("ACCOUNT DETAILS")}>
          edit your account details
        </span>
        .
      </p>
    </div>
  );

  // Orders Page
  const OrdersPage = () => {
    const initialOrders = [
      { id: 1, date: "12 Oct 2025", status: "Delivered", total: "₹1,299.00", invoice: "INV-001" },
      { id: 2, date: "08 Oct 2025", status: "Processing", total: "₹2,499.00", invoice: "INV-002" },
      { id: 3, date: "02 Oct 2025", status: "Cancelled", total: "₹799.00", invoice: "INV-003" },
    ];

    const [orders] = useState(() => {
      const saved = localStorage.getItem("orders");
      return saved ? JSON.parse(saved) : initialOrders;
    });

    const statusStyle = (status) => {
      if (status === "Delivered") return { color: "#2e8b57", fontWeight: "600" };
      if (status === "Processing") return { color: "#e69500", fontWeight: "600" };
      return { color: "#d9534f", fontWeight: "600" };
    };

    return (
      <div style={styles.card}>
        <h3 style={styles.fsXxl}>My Orders</h3>
        <div style={{ overflowX: "auto", ...styles.table }}>
          <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "20px" }}>
            <thead>
              <tr style={{ backgroundColor: "#f3f3f3", textAlign: "left" }}>
                <th style={{ padding: "12px" }}>Order Date</th>
                <th style={{ padding: "12px" }}>Status</th>
                <th style={{ padding: "12px" }}>Total</th>
                <th style={{ padding: "12px" }}>Invoice</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => (
                <tr key={order.id}>
                  <td style={{ padding: "12px" }}>{order.date}</td>
                  <td style={{ padding: "12px" }}><span style={statusStyle(order.status)}>{order.status}</span></td>
                  <td style={{ padding: "12px" }}>{order.total}</td>
                  <td style={{ padding: "12px" }}><span style={{ textDecoration: "underline", cursor: "pointer" }}>{order.invoice}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  // Downloads Page
  const DownloadsPage = () => {
    const downloadedFiles = [
      { id: 1, name: "Invoice_INV-001.pdf", type: "PDF", date: "12 Oct 2025", url: "/downloads/INV-001.pdf" },
      { id: 2, name: "Invoice_INV-002.pdf", type: "PDF", date: "08 Oct 2025", url: "/downloads/INV-002.pdf" },
      { id: 3, name: "Product_Brochure.pdf", type: "PDF", date: "05 Oct 2025", url: "/downloads/Brochure.pdf" },
    ];

    return (
      <div style={styles.card}>
        <h3 style={styles.fsXxl}>My Downloads</h3>
        {downloadedFiles.length === 0 ? <p>No downloads available yet.</p> : (
          <div style={{ overflowX: "auto", ...styles.table }}>
            <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "20px" }}>
              <thead>
                <tr style={{ backgroundColor: "#f3f3f3", textAlign: "left" }}>
                  <th style={{ padding: "12px" }}>File Name</th>
                  <th style={{ padding: "12px" }}>Type</th>
                  <th style={{ padding: "12px" }}>Date</th>
                  <th style={{ padding: "12px" }}>Download</th>
                </tr>
              </thead>
              <tbody>
                {downloadedFiles.map((file) => (
                  <tr key={file.id}>
                    <td style={{ padding: "12px" }}>{file.name}</td>
                    <td style={{ padding: "12px" }}>{file.type}</td>
                    <td style={{ padding: "12px" }}>{file.date}</td>
                    <td style={{ padding: "12px" }}><a href={file.url} download style={{ textDecoration: "underline", color: "#2e8b57" }}>Download</a></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };

  // Account Details with Edit & Update buttons
  const AccountDetailsPage = () => {
    const [editing, setEditing] = useState(false);
    const [account, setAccount] = useState(() => {
      const saved = localStorage.getItem("account");
      return saved ? JSON.parse(saved) : {
        name: "Admin User",
        email: "admin@example.com",
        password: "password123",
        fullName: "Admin User",
        street: "123 Street",
        city: "City",
        state: "State",
        zip: "123456",
        country: "Country",
      };
    });

    const handleChange = (e) => setAccount({ ...account, [e.target.name]: e.target.value });

    const handleUpdate = () => {
      localStorage.setItem("account", JSON.stringify(account));
      setEditing(false);
      alert("Account updated successfully!");
    };

    const fields = Object.keys(account);

    return (
      <div style={styles.card}>
        <h3 style={styles.fsXl}>Account Details</h3>
        <form style={{ marginTop: "20px" }} onSubmit={(e) => e.preventDefault()}>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
            {fields.map((field) => (
              <div key={field} style={{ flex: "1 1 45%" }}>
                <label style={{ display: "block", marginBottom: "4px", fontWeight: "600", textTransform: "capitalize" }}>{field.replace(/([A-Z])/g, " $1")}</label>
                <input
                  type={field.toLowerCase().includes("password") ? "password" : "text"}
                  name={field}
                  value={account[field]}
                  onChange={handleChange}
                  disabled={!editing}
                  style={{ width: "100%", padding: "8px", borderRadius: "6px", border: "1px solid #ccc" }}
                />
              </div>
            ))}
          </div>
          <div style={{ textAlign: "right", marginTop: "20px", display: "flex", gap: "10px", justifyContent: "flex-end" }}>
            {!editing && (
              <button type="button" onClick={() => setEditing(true)} style={{ padding: "10px 20px", backgroundColor: "#ffc107", color: "#000", border: "none", borderRadius: "6px", cursor: "pointer" }}>
                Edit
              </button>
            )}
            {editing && (
              <button type="button" onClick={handleUpdate} style={{ padding: "10px 20px", backgroundColor: "#007bff", color: "#fff", border: "none", borderRadius: "6px", cursor: "pointer" }}>
                Update
              </button>
            )}
          </div>
        </form>
      </div>
    );
  };

  const renderContent = () => {
    let content;
    switch (activeItem) {
      case "DASHBOARD": content = <DashboardHome />; break;
      case "ORDERS": content = <OrdersPage />; break;
      case "DOWNLOADS": content = <DownloadsPage />; break;
      case "ACCOUNT DETAILS": content = <AccountDetailsPage />; break;
      default: content = <DashboardHome />;
    }
    return (
      <AnimatePresence mode="wait">
        <motion.div key={activeItem} initial={{ opacity: 0, x: 50 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -50 }} transition={{ duration: 0.3 }}>
          {content}
        </motion.div>
      </AnimatePresence>
    );
  };

  const menuItems = ["DASHBOARD", "ORDERS",   "ACCOUNT DETAILS"]; // "DOWNLOADS" if want just add this ,

  const styles = {
    desktopContainer: {
      display: "flex",
      flexDirection: "row",
      fontFamily: "'Montserrat', sans-serif",
      color: "#222",
      minHeight: "100vh",
      maxWidth: "1200px",
      margin: "20px auto",
      padding: "0 20px",
      alignItems: "flex-start",
    },

    mobileContainer: {
      display: "flex",
      flexDirection: "column",
      fontFamily: "'Montserrat', sans-serif",
      color: "#222",
      padding: "20px 15px",
      height: "100vh",
      boxSizing: "border-box",
      backgroundColor: "#fff",
      overflow: "hidden",
    },

    sidebar: {
      border: "1px solid #e5e5e5",
      borderRadius: "12px",
      backgroundColor: "#fff",
      width: "250px",
      marginRight: "20px",
      marginTop: "50px",
      flexShrink: 0,
      boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
      display: "flex",
      flexDirection: "column",
      height: "310px",
      overflowY: "auto",
    },

    sidebarList: { listStyle: "none", margin: 0, padding: 0 },

    li: (isActive) => ({
      borderBottom: "1px solid #e5e5e5",
      padding: "14px 18px",
      fontSize: "16px",
      cursor: "pointer",
      backgroundColor: isActive ? "#f3faf1" : "transparent",
      fontWeight: isActive ? "700" : "600",
      borderRadius: "6px",
      color: "#185E37",
      transition: "all 0.2s ease",
    }),

    lastLi: {
      borderBottom: "none",
      padding: "14px 18px",
      fontSize: "16px",
      cursor: "pointer",
      fontWeight: "600",
      color: "red",
      borderRadius: "6px",
      transition: "all 0.2s ease",
    },

    card: {
      borderRadius: "12px",
      border: "1px solid #eee",
      padding: "15px",
      marginBottom: "20px",
      marginTop: "0px",
      boxShadow: "0 6px 12px rgba(0,0,0,0.05)",
      backgroundColor: "#fff",
    },

    contentWrapperDesktop: {
      flex: 1,
      padding: "20px 10px",
      boxSizing: "border-box",
      backgroundColor: "#fff",
      marginTop: "30px", // added top margin for right card
    },

    contentWrapperMobile: {
      flex: 1,
      overflowY: "auto",
      padding: "20px 10px",
      boxSizing: "border-box",
      backgroundColor: "#fff",
    },

    mobileTabs: {
      flexShrink: 0,
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      padding: "15px 0",
    },

    mobileTab: (isActive) => ({
      border: "1px solid #ccc",
      borderRadius: "6px",
      padding: "14px 18px",
      cursor: "pointer",
      fontWeight: isActive ? "700" : "600",
      backgroundColor: isActive ? "#f3faf1" : "transparent",
      transition: "all 0.2s ease",
    }),

    logoutTab: {
      border: "1px solid #ccc",
      borderRadius: "6px",
      padding: "14px 18px",
      cursor: "pointer",
      fontWeight: "600",
      color: "red",
      transition: "all 0.2s ease",
    },
  };

  return (
    <>
      {/* Desktop Layout */}
      <div className="d-none d-md-flex fs-lg" style={styles.desktopContainer}>
        <nav style={styles.sidebar}>
          <ul style={styles.sidebarList}>
            {menuItems.map(item => (
              <li
                key={item}
                style={styles.li(activeItem === item)}
                onClick={() => setActiveItem(item)}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f3faf1")}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = activeItem === item ? "#e8f5e9" : "transparent";
                }}
              >
                {item}
              </li>
            ))}
            <li
              style={styles.lastLi}
              onClick={handleLogout}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f3faf1")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
            >
              LOG OUT
            </li>
          </ul>
        </nav>

        <main style={styles.contentWrapperDesktop}>
          {renderContent()}
        </main>
      </div>

      {/* Mobile Layout */}
      <div className="d-md-none fs-lg" style={styles.mobileContainer}>
        <div style={styles.mobileTabs}>
          {menuItems.map((item) => (
            <div
              key={item}
              style={styles.mobileTab(activeItem === item)}
              onClick={() => setActiveItem(item)}
            >
              {item}
            </div>
          ))}
          <div style={styles.logoutTab} onClick={handleLogout}>LOG OUT</div>
        </div>

        <main style={styles.contentWrapperMobile}>
          {renderContent()}
        </main>
      </div>
    </>
  );
};

export default Dashboard;
